import { Query, DataManager, Deferred } from '@syncfusion/ej2-data';
/**
 * data module is used to generate query and dataSource
 */
export class Data {
    /**
     * Constructor for data module
     *
     * @param dataSource
     * @param query
     * @param dataSource
     * @param query
     * @private
     */
    constructor(dataSource, query) {
        this.initDataManager(dataSource, query);
    }
    /**
     * The function used to initialize dataManager and query
     *
     * @param dataSource
     * @param query
     * @param dataSource
     * @param query
     * @returns {void}
     * @private
     */
    initDataManager(dataSource, query) {
        this.dataManager = dataSource instanceof DataManager ? dataSource : new DataManager(dataSource);
        this.query = query instanceof Query ? query : new Query();
    }
    /**
     * The function used to generate updated Query from chart model
     *
     * @returns {void}
     * @private
     */
    generateQuery() {
        const query = this.query.clone();
        return query;
    }
    /**
     * The function used to get dataSource by executing given Query
     *
     * @param  {Query} query - A Query that specifies to generate dataSource
     * @returns {void}
     * @private
     */
    getData(dataQuery) {
        if (this.dataManager.ready) {
            const dataManagerDeferred = new Deferred();
            const ready = this.dataManager.ready;
            ready.then(() => {
                this.dataManager.executeQuery(dataQuery).then((result) => {
                    dataManagerDeferred.resolve(result);
                });
            }).catch((e) => { dataManagerDeferred.reject(e); });
            return dataManagerDeferred.promise;
        }
        else {
            return this.dataManager.executeQuery(dataQuery);
        }
    }
}
